<template>
  <div class="wrapper">
    <div
      :class="checked ? 'checkbox checked' : 'checkbox'"
      @click="handleToggle()"
    />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "Checkbox",
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle'],
  setup(props, context) {
    const store = useStore();
    const handleToggle = () => {
      context.emit('toggle');
    };
    return {
      state: store.state,
      build: store.state.build,
      handleToggle,
    };
  },
});
</script>
<style scoped>
.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.checkbox {
  cursor: pointer;
  /* position: relative; */
  width: 9px;
  height: 9px;
  border: 1px solid var(--text-white);
  box-shadow: var(--text-shadow);
  border-radius: 50%;
}
.checkbox:hover {
  box-shadow: var(--text-shadow);
}
.checked {
  background-color: var(--text-tagged);
  border: var(--checkbox-border-selected)
}
</style>